import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { AppState } from '../../store';
import { ClientsState } from "../../store/clients/types";
import { SystemState } from "../../store/system/types";
import { DestinationsState } from "../../store/destinations/types";
import { loadClients } from "../../store/clients/actions";
import { loadDestinations, saveProductEventsConfig, deleteDestination } from "../../store/destinations/actions";
import AppHeader from "../../components/header/header";
import Spinner from "../../components/spinner";
import ProductEventsConfig from "./ProductEventsConfig";
import './productEvents.css';

interface ProductEventsProps {
  loadClients: typeof loadClients;
  loadDestinations: typeof loadDestinations;
  saveDestination: any;
  deleteDestination: any;
  clients: ClientsState;
  system: SystemState;
  destinations: DestinationsState;
  history: any;
}

const ProductEvents: React.FC<ProductEventsProps> = (props) => {
  useEffect(() => {
    props.loadDestinations();
  }, []);

  // selectedClient is null on first paint (the Triggers screen dereferences it
  // unguarded — do not copy that). Destinations are scoped server-side by the
  // X-On-Behalf header set in lib/axios.ts, so the fetch must follow selection.
  if (!props.system.selectedClient) {
    return <Spinner />;
  }

  const all = props.destinations.destinations || [];
  // One product_view destination per client is the engine invariant (the poller
  // does ORDER BY id DESC LIMIT 1).
  const config = all.filter((d: any) => d && d.type === 'product_view')[0] || null;

  return (
    <>
      <AppHeader />
      <div className="product_events">
        <h2 className='section_title'>Product Events</h2>
        {props.destinations.loading ? <Spinner /> : (
          <ProductEventsConfig
            clientId={Number(props.system.selectedClient.id)}
            config={config}
            saveDestination={props.saveDestination}
            deleteDestination={props.deleteDestination}
            history={props.history}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  clients: state.clients,
  system: state.system,
  destinations: state.destinations
});

const mapDispatchToProps = (dispatch) => {
  return {
    loadClients: () => dispatch(loadClients()),
    loadDestinations: () => dispatch(loadDestinations()),
    saveDestination: (destination) => dispatch(saveProductEventsConfig(destination)),
    deleteDestination: (id) => dispatch(deleteDestination(id))
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProductEvents)
);
